<script setup lang="ts">
import { PopoverArrow, PopoverContent, PopoverPortal, PopoverRoot, PopoverTrigger } from "reka-ui"

interface PopoverProps {
  content?: string
  side?: "top" | "bottom" | "left" | "right"
  hover?: boolean
  sideOffset?: number
}

const props = withDefaults(defineProps<PopoverProps>(), {
  content: "",
  side: "top",
  hover: false,
  sideOffset: 2,
})

const isOpen = defineModel<boolean>("open", { default: false })

function handleMouseEnter() {
  if (props.hover) {
    isOpen.value = true
  }
}

function handleMouseLeave() {
  if (props.hover) {
    isOpen.value = false
  }
}

function close() {
  isOpen.value = false
}
</script>

<template>
  <PopoverRoot v-model:open="isOpen">
    <PopoverTrigger
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    >
      <slot />
    </PopoverTrigger>
    <PopoverPortal>
      <PopoverContent
        class="max-w-[calc(100vw-2rem)] select-none break-words whitespace-normal rounded-md border bg-white px-[15px] py-[10px] text-sm leading-normal shadow-sm will-change-[transform,opacity] z-50"
        :side-offset="sideOffset"
        :side="side"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <slot name="content" :close="close">
          {{ content }}
        </slot>
        <PopoverArrow
          class="fill-white stroke-gray-200"
          :width="12"
          :height="6"
        />
      </PopoverContent>
    </PopoverPortal>
  </PopoverRoot>
</template>
